import { Component } from '@angular/core';

/** Tab root for the project-level Risk register tab. */
@Component({
  selector: 'app-risk-register-wrapper',
  templateUrl: './risk-register-wrapper.component.html',
  styleUrls: ['./risk-register-wrapper.component.scss'],
  standalone: false,
})
export class RiskRegisterWrapperComponent {}
